import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Site } from '../../types/site';
import { getRedirerectUrl } from './localtionHelper';

export default function SiteSelection(props: {
  sites: Site[];
  selectedSiteId: number;
  onChangeSite: (siteId: number) => void;
}) {
  const location = useLocation();
  return (
    <React.Fragment>
      <ul className="tab floatr">
        {props.sites.map((x, i) => (
          <li
            key={x.siteId}
            className={`${i === 0 ? 'first' : ''} ${
              props.selectedSiteId === x.siteId ? 'active' : ''
            }`}>
            {props.selectedSiteId !== x.siteId ? (
              <Link
                onClick={() => {
                  if (props.selectedSiteId !== x.siteId)
                    props.onChangeSite(x.siteId);
                }}
                to={getRedirerectUrl(location.pathname)}>
                {x.siteName}
              </Link>
            ) : (
              <Link to={getRedirerectUrl(location.pathname)}>{x.siteName}</Link>
            )}
          </li>
        ))}
      </ul>
    </React.Fragment>
  );
}
